import React, { useEffect, useState } from "react";
import "../../../Pages/AdminScreens/EmployeeProfile/EmployeeProfile.css";
import { BiHomeAlt } from "react-icons/bi";
import { MdKeyboardArrowRight } from "react-icons/md";
import {
  Modal,
  OverlayTrigger,
  Tooltip,
  useAccordionButton,
} from "react-bootstrap";
import profileimg from "../../../Assets/Images/profileimg.png";
import { FaPhoneAlt } from "react-icons/fa";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import Header from "../../../Components/Dashboard/Header/Header";
import Sidebar from "../../../Components/Dashboard/Sidebar/Sidebar";
import NewEmployeesModal from "../../../Components/Modals/NewEmployeesModal";
import { useLocation } from "react-router-dom";
import { Apiurl, GetToken } from "../../../Utils/utils";
import axios from "axios";

const EmployeeProfile = () => {
  const LoginToken = GetToken();
  const location = useLocation();
  const comingData = location.state;
  const [showSidebar, setShowSidebar] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [EmpData, setEmpData] = useState("");
  const GetProfile = () => {
    // setLoading(true);
    const option = {
      method: "GET",
      headers: {
        "access-control-allow-origin": "*",
        "content-type": "application/json",
        authorization: `Bearer ${LoginToken}`,
      },
      url: `${Apiurl()}/Profile/GetProfile`,
    };
    axios(option)
      .then((e) => {
        // setLoading(false);
        const data = JSON.parse(e?.data?.data);
        setEmpData(data);
        comingData(data);
        // setUserNameHr(data?.FirstName)
      })
      .catch(() => {
        // setLoading(false);
      });
  };
  useEffect(() => {
    GetProfile();
  }, []);

  useEffect(() => {
    if (window.innerWidth < 600) {
      const timeoutId = setTimeout(() => {
        setShowSidebar(false);
      }, 1000);
      return () => clearTimeout(timeoutId);
    }
    setShowSidebar(true);
  }, []);
  const address = comingData?.Address || EmpData?.Address;

  return (
    <>
      <Header showSidebar={showSidebar} setShowSidebar={setShowSidebar} />
      <div className="d-flex">
        <Sidebar showSidebar={showSidebar} />

        <>
          <div
            className={
              showSidebar
                ? "main-container-of-all-employees-page-profile"
                : "main-container-of-all-employees-page-profile-new"
            }
          >
            <div className="inner-container-of-all-employees-page ">
              <div className="header-of-employees-page row">
                <div className="all-employee-text-profile col">
                  <h4>Profile</h4>
                </div>
                <div className="all-employees-directory-profile col">
                  <div className="home-icon-header-profile">
                    <BiHomeAlt className="home-icon-header-inn" />
                  </div>
                  <div className="arrow-icon-header-profile">
                    <MdKeyboardArrowRight />
                  </div>
                  <div className="employee-text-header-profile">
                    <p>Employees</p>
                  </div>
                  <div className="arrow-icon-header-profile">
                    <MdKeyboardArrowRight />
                  </div>
                  <div className="all-employee-text-header-profile">
                    <p>Profile</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="body-part-outer-container-profile">
              <div className="table-in-all-emplyee-body-profile">
                <div className="row">
                  <div className="second-card-main-container-withcol col-12">
                    <div className="card-and-about-contant">
                      <div className="first-card-main-container  col-4">
                        <div className="inner-container-of-first-card">
                          <div className="first-card-of-body-in-employee-table">
                            {comingData?.FirstName || EmpData?.FirstName ? (
                              <p className="dr-john-smith">
                                {comingData?.FirstName || EmpData?.FirstName}
                              </p>
                            ) : (
                              <p className="dr-john-smith">-</p>
                            )}
                            {comingData?.Designations?.DesignationName ? (
                              <p className="senior-empolyee">
                                {comingData?.Designations?.DesignationName}
                              </p>
                            ) : (
                              <p className="senior-empolyee">-</p>
                            )}
                          </div>
                          <div className="porfile-image-main-div">
                            {comingData?.UrlLink ? (
                              <img
                                src={comingData?.UrlLink || EmpData?.UrlLink}
                                alt=""
                                className="profileimage-class"
                              />
                            ) : (
                              <img
                                src={profileimg}
                                alt=""
                                className="profileimage-class"
                              />
                            )}
                          </div>
                          <div>
                            {comingData?.Address || EmpData?.Address ? (
                              <p className="senior-empolyee-details">
                                {comingData?.Address || EmpData?.Address}
                              </p>
                            ) : (
                              <p className="senior-empolyee-details">-</p>
                            )}
                            <span className="phone-icon-and-number">
                              <FaPhoneAlt />

                              {comingData?.Mobile || EmpData?.Mobile ? (
                                <p>{comingData?.Mobile || EmpData?.Mobile}</p>
                              ) : (
                                <p>-</p>
                              )}
                            </span>
                          </div>
                        </div>
                        <div className="about-and-skill-card-main"></div>
                      </div>
                      <div className="profile-only-info">
                        <h3 className="ueryr">About me</h3>
                        <div className="row">
                          <div className="all-details-of-userlogin ">
                            <div className=" full-name-detail  col-3">
                              <strong>Full Name </strong>
                              {comingData?.FirstName || EmpData?.FirstName ? (
                                <p>
                                  {comingData?.FirstName || EmpData?.FirstName}
                                </p>
                              ) : (
                                <p>-</p>
                              )}
                            </div>
                            <div className="mobile-number-detail col-3">
                              <strong>Mobile </strong>
                              {comingData?.Mobile || EmpData?.Mobile ? (
                                <p>{comingData?.Mobile || EmpData?.Mobile}</p>
                              ) : (
                                <p>-</p>
                              )}
                            </div>
                            <div className="email-detail col-3">
                              <strong>Email</strong>
                              <OverlayTrigger
                                placement="left"
                                overlay={
                                  <Tooltip id="tooltip">
                                    {comingData?.Email || EmpData?.Email}
                                  </Tooltip>
                                }
                              >
                                {comingData?.Email || EmpData?.Email ? (
                                  <p>
                                    {(comingData?.Email || EmpData?.Email)
                                      .length > 15
                                      ? (
                                          comingData?.Email || EmpData?.Email
                                        ).substring(0, 15) + "..."
                                      : comingData?.Email || EmpData?.Email}
                                  </p>
                                ) : (
                                  <p>-</p>
                                )}
                              </OverlayTrigger>
                            </div>
                            <div className="location-details col-3">
                              <strong>Location </strong>
                              {comingData?.Address || EmpData?.Address ? (
                                <p className="senior-employee-details">
                                  {(comingData?.Address || EmpData?.Address)
                                    .length > 15
                                    ? (
                                        comingData?.Address || EmpData?.Address
                                      ).substring(0, 15) + "..."
                                    : comingData?.Address || EmpData?.Address}
                                </p>
                              ) : (
                                <p className="senior-employee-details">-</p>
                              )}
                            </div>
                          </div>

                          <div className="education-details-of-employee-new">
                            <div className="education-heading-main-new">
                              <h2>Education</h2>
                            </div>
                            <div className="education-details-pera-new">
                              <p>
                                M.B.B.S.,Gujarat University, Ahmedabad,India.
                              </p>
                              <p>M.S.,Gujarat University, Ahmedabad, India.</p>
                            </div>
                          </div>
                          <div className="education-details-of-employee"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
        <></>
      </div>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        className="modal-in-employee-table"
      >
        <NewEmployeesModal className="modal-main-inner-container" />
      </Modal>
    </>
  );
};

export default EmployeeProfile;
